import PhoneSet from './PhoneSet'
export default PhoneSet;